import {downloadPdf} from '@Components/pdf-lightbox/pdf-lightbox.library';
import {FeedbackType} from '@Components/ai-chat-window/ai-chat-window.types';
import {EntityCardEntityType} from '@Components/ai-chat-window/components/entity-card/entity-card.types';
import type {EntityCardAction} from './entity-card-action.types';

interface PdfEntityPayload {
  url: string;
  title?: string;
}

/**
 * Clicking a PDF card opens the generated document in the shared chat lightbox
 * (an inline iframe), keeping the user in the conversation. The lightbox itself
 * offers an "open in new tab" escape hatch for downloading or mobile viewing.
 */
export const pdfEntityCardAction: EntityCardAction<PdfEntityPayload> = {
  entityType: EntityCardEntityType.PDF,
  cardActions: [
    {
      icon: 'icon-thumbs-up',
      ariaLabelKey: 'pmwjs_good_response',
      isSelected: (ctx): boolean => ctx.feedback?.type === FeedbackType.POSITIVE,
      run: (_payload, ctx): void => {
        ctx.recordFeedback(FeedbackType.POSITIVE);
      },
    },
    {
      icon: 'icon-thumbs-down',
      ariaLabelKey: 'pmwjs_bad_response',
      isSelected: (ctx): boolean => ctx.feedback?.type === FeedbackType.NEGATIVE,
      run: (_payload, ctx): void => {
        ctx.recordFeedback(FeedbackType.NEGATIVE);
      },
    },
    {
      icon: 'icon-download',
      ariaLabelKey: 'pmwjs_download',
      run: async (payload): Promise<void> => {
        if (payload.url === '') {
          return;
        }

        await downloadPdf(payload.url, payload.title);
      },
    },
  ],
  parsePayload: (raw): PdfEntityPayload => ({
    url: typeof raw.url === 'string' ? raw.url : '',
    title: typeof raw.title === 'string' ? raw.title : undefined,
  }),
  onClick: (payload, ctx): void => {
    if (payload.url === '') {
      return;
    }
    ctx.openPdf(payload.url, payload.title);
  },
};
